import { styled } from 'styled-components'

import { Typography } from '../../Typography'

export const SegmentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  ${Typography} {
    white-space: pre-line;
  }
`

export const SegmentHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`

export const SegmentCard = styled.div`
  border-radius: ${({ theme }) => theme.radius['Radius LG']}px;
  background: ${({ theme }) => theme.colors['N Surface/Primary']};
  color: ${({ theme }) => theme.colors['N Content/Primary']};
`

export const SegmentLoaderContainer = styled.div`
  .react-loading-skeleton {
    border-radius: ${({ theme }) => theme.radius['Radius LG']}px !important;
  }
`
